import { useState } from 'react';
import { MainTitle } from 'components/MainTitle';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import styles from './Refund.module.scss';
import { InputSearch } from 'ui/InputSearch';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { QueryParamsRefundType } from 'redux/Api/refundApi/type';
import { useGetRefundQuery } from 'redux/Api/refundApi/refundApi';
import { RefundList } from 'components/RefundList';

export const Refund = () => {
  const [searchValue, setSearchValue] = useState('');

  const per_page = 50;

  const [queryParams, setQueryParams] = useState<QueryParamsRefundType>({
    page: 1,
    per_page,
  });

  const { data, isLoading } = useGetRefundQuery(queryParams);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      setQueryParams((prev) => ({
        ...prev,
        page: 1,
        search: searchValue || undefined,
      }));
    }
  };

  const hasNextPage = data?.meta
    ? data?.meta?.last_page !== data?.meta?.current_page
    : false;

  const [intersectionRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage,
    onLoadMore: () => setQueryParams((prev) => ({ ...prev, page: prev.page + 1 })),
    rootMargin: '0px 0px 800px 0px',
  });

  return (
    <div className={styles.root}>
      <MainTitle title='Возвраты' count={data?.meta.total} />

      <div className={styles.search}>
        <InputSearch
          notFocus
          placeholder='Искать'
          value={searchValue}
          onKeyDown={handleKeyDown}
          onSearch={() => {
            setQueryParams((prev) => ({
              ...prev,
              page: 1,
              search: searchValue || undefined,
            }));
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSearchValue(e.target.value);

            if (e.target.value === '') {
              setQueryParams((prev) => ({
                ...prev,
                page: 1,
                search: undefined,
              }));
            }
          }}
        />
      </div>

      {isLoading ? (
        <LoadingSkeleton mt />
      ) : (
        <RefundList data={data?.data?.items || []} intersectionRef={intersectionRef} />
      )}
    </div>
  );
};
